module.exports = __webpack_public_path__ + "static/img/2.12ba706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/2.jpg
// module id = kUlE
// module chunks = 4